import { isPlatformServer } from '@angular/common';
import {
  afterNextRender,
  DOCUMENT,
  inject,
  Injectable,
  Injector,
  PLATFORM_ID,
} from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  Router,
} from '@angular/router';
import { filter, take } from 'rxjs/operators';
import {
  BOOT_SPLASH_ELEMENT_ID,
  BOOT_SPLASH_FADE_MS,
  BOOT_SPLASH_HIDDEN_CLASS,
} from './boot-splash.constants';

@Injectable({
  providedIn: 'root',
})
export class BootSplashService {
  private readonly document = inject(DOCUMENT);
  private readonly router = inject(Router);
  private readonly injector = inject(Injector);
  private readonly platformId = inject(PLATFORM_ID);

  public hideAfterFirstNavigation(): void {
    if (isPlatformServer(this.platformId)) {
      this.splash()?.remove();
      return;
    }

    this.router.events
      .pipe(
        filter(
          (event) =>
            event instanceof NavigationEnd ||
            event instanceof NavigationCancel ||
            event instanceof NavigationError,
        ),
        take(1),
      )
      .subscribe(() =>
        afterNextRender(() => this.fadeOut(), { injector: this.injector }),
      );
  }

  private fadeOut(): void {
    const splash = this.splash();
    if (!splash) return;

    splash.classList.add(BOOT_SPLASH_HIDDEN_CLASS);
    setTimeout(() => splash.remove(), BOOT_SPLASH_FADE_MS);
  }

  private splash(): HTMLElement | null {
    return this.document.getElementById(BOOT_SPLASH_ELEMENT_ID);
  }
}
